"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSvg = require("react-svg");
var _NavItem = _interopRequireDefault(require("../../Molecules/NavItem"));
var L2Panel = function L2Panel(props) {
  var className = props.className,
    data = props.data,
    path = props.path,
    closeIcon = props.closeIcon,
    closeNavigationDrawer = props.closeNavigationDrawer;
  var numberOfLinks = data.length;
  var maxColumnCount = 3;
  var linksPerColumn = 8;
  var columnCount = numberOfLinks === 0 ? 1 : Math.ceil(numberOfLinks / linksPerColumn);
  var prefixId = path.split('/');
  prefixId = prefixId[prefixId.length - 1];
  var classNameL2 = "cmp-navigation__group cmp-navigation__group--col-" + (columnCount > maxColumnCount ? maxColumnCount : columnCount);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
    className: className
  }, _react.default.createElement(_NavItem.default, {
    className: classNameL2,
    liClassName: "cmp-navigation__item",
    divClassName: "cmp-navigation__container",
    linkClassName: "cmp-navigation__item-link",
    data: data
  }), _react.default.createElement("div", {
    id: prefixId + "-target-container",
    className: "cmp-navigation__adobe-target-container at-element-marker"
  }), _react.default.createElement("button", {
    onClick: closeNavigationDrawer,
    className: "cmp-navigation__close-icon",
    "data-locator": "cmp-navigation-close-button"
  }, _react.default.createElement(_reactSvg.ReactSVG, {
    wrapper: "span",
    src: closeIcon,
    "data-locator": "cmp-navigation-close-icon"
  }))));
};
L2Panel.defaultProps = {
  title: '',
  closeIcon: '',
  closeNavigationDrawer: function closeNavigationDrawer() {
    /* default closeNavigationDrawer handler */
  }
};
var _default = L2Panel;
exports.default = _default;
module.exports = exports["default"];